import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Grid } from '@mui/material'
import { GridColDef, GridToolbarContainer } from '@mui/x-data-grid'
import { useQuery } from '@tanstack/react-query'
import PaymentAPI from 'api/orbitV1/PaymentAPI'
import CustomSearchbar from 'common/AbstractDataGrid/CustomSearchbar'
import MUIDataGrid from 'common/AbstractDataGrid/DataGridMUI'
import { ColorBoxContent } from 'common/ui/colorBox'
import { PaymentGetDataBase } from 'types/api/v1/payment.type'

import PaymentTableRowMenu from './PaymentTableRowMenu'

// const ORDER_LIMIT = 50 Remove order_limit temporarily

// interface IDataProps {
//   title: string
//   info: number
// }

const AccountToolbar = () => {
  return (
    <GridToolbarContainer
      sx={{
        justifyContent: 'space-between'
      }}
    >
      <CustomSearchbar />
    </GridToolbarContainer>
  )
}

export default function PaymentTable() {
  const navigate = useNavigate()

  const [retrievedIntents, setRetrievedIntents] = useState<
    PaymentGetDataBase[]
  >([])

  const { data: getAllIntents } = useQuery(
    ['getAllintents', 'paymentManagement'],
    async () => {
      return PaymentAPI.getAllIntents()
    }
  )

  // Payment handler

  const handleSetPaid = (payIntentId: string) => {
    PaymentAPI.updateIntent({ payIntentId, paymentStatus: 'succeeded' })
      .then(() => navigate(0))
      .catch((e) => {
        toast.error(`Error updating intent: ${e}`)
      })
  }

  useEffect(() => {
    if (getAllIntents) {
      const intents = getAllIntents.data
      setRetrievedIntents(intents)
    }
  }, [getAllIntents])

  const columns: GridColDef[] = [
    { field: 'customer', headerName: 'Customer Name', width: 100 },
    { field: 'payIntentId', headerName: 'Mobile No.', width: 100 }, // Change to mobile no.
    {
      field: 'orderNo',
      headerName: 'Order No.',
      width: 100,
      valueGetter: (params) => {
        const intent: PaymentGetDataBase = params.row
        return intent.metadata.orderNo
      }
    },
    { field: 'paymentStatus', headerName: 'Payment Status', width: 50 },
    { field: 'updatedAt', headerName: 'Updated', width: 50 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 50,
      renderCell: (params) => {
        const intent: PaymentGetDataBase = params.row
        return (
          <PaymentTableRowMenu intent={intent} handleSetPaid={handleSetPaid} />
        )
      }
    }
  ]

  return (
    <Grid container direction='column' spacing={2}>
      <Grid item>
        <ColorBoxContent>
          <MUIDataGrid
            getRowId={(intent: PaymentGetDataBase) =>
              intent.metadata.orderNo + intent._id
            }
            initialState={{
              sorting: {
                sortModel: [{ field: 'createdAt', sort: 'desc' }]
              }
            }}
            rows={retrievedIntents}
            columns={columns}
            components={{ Toolbar: AccountToolbar }}
          />
        </ColorBoxContent>
      </Grid>
    </Grid>
  )
}
